function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("react"), require("highcharts")) : "function" == typeof define && define.amd ? define(["react", "highcharts"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.HighchartsReact = t(require("react"), require("highcharts")) : e.HighchartsReact = t(e.React, e.Highcharts);
}("undefined" != typeof self ? self : this, function (e, t) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 0);
  }([function (e, t, r) {
    "use strict";

    function n() {
      return n = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      }, n.apply(this, arguments);
    }

    function o(e) {
      return i(e) || u(e) || c();
    }

    function c() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }

    function u(e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }

    function i(e) {
      if (Array.isArray(e)) {
        for (var t = 0, r = new Array(e.length); t < e.length; t++) {
          r[t] = e[t];
        }

        return r;
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = r(1),
        s = r.n(a),
        f = r(2),
        p = r.n(f),
        l = "undefined" != typeof window ? a.useLayoutEffect : a.useEffect,
        d = Object(a.forwardRef)(function (e, t) {
      var r = Object(a.useRef)(),
          c = Object(a.useRef)();
      return l(function () {
        function t() {
          var t = e.highcharts || p.a,
              n = e.constructorType || "chart";
          t ? t[n] ? e.options ? c.current = t[n](r.current, e.options, e.callback ? e.callback : void 0) : console.warn('The "options" property was not passed.') : console.warn('The "constructorType" property is incorrect or some required module is not imported.') : console.warn('The "highcharts" property was not passed.');
        }

        if (c.current) {
          if (!1 !== e.allowChartUpdate) if (!e.immutable && c.current) {
            var n;
            (n = c.current).update.apply(n, [e.options].concat(o(e.updateArgs || [!0, !0])));
          } else t();
        } else t();
      }), l(function () {
        return function () {
          c.current && (c.current.destroy(), c.current = null);
        };
      }, []), Object(a.useImperativeHandle)(t, function () {
        return {
          get chart() {
            return c.current;
          },

          container: r
        };
      }, []), s.a.createElement("div", n({}, e.containerProps, {
        ref: r
      }));
    });
    t["default"] = Object(a.memo)(d);
  }, function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }]);
});